import React, { useRef } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { TableLoader } from "../../commons";
import LargeAvatar from "../../commons/CircularAvatar/LargeCircularAvatar";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { EmployeeWithoutFillTimesheetListType } from "../../../redux/timeSheet/timeSheetType";
type AppProps = {
  isOpen: boolean;
  toggle: () => void;
  fetching: boolean;
  employeeWithoutFillTimesheetList: EmployeeWithoutFillTimesheetListType[] | [];
  listOffset: number;
};
const OpenEmployeeWithNoTimesheetEntry = ({
  isOpen,
  toggle,
  fetching,
  employeeWithoutFillTimesheetList,
  listOffset,
}: AppProps) => {
  const scrollRef = useRef<any>("");

  return (
    <div>
      <Modal
        centered
        isOpen={isOpen}
        toggle={toggle}
        size="lg"
        backdrop="static"
      >
        <ModalHeader
          className="pt-3 pl-4"
          id="cross-cut"
          toggle={toggle}
          style={{ paddingBottom: "13px" }}
        >
          Employee with no timesheet entry
        </ModalHeader>
        <ModalBody
          className="pl-4 pr-4"
          style={{ paddingLeft: "40px", maxWidth: "0 auto" }}
        >
          <>
            <div
              ref={scrollRef}
              className="pl-1"
              style={{ height: "400px", overflowY: "scroll" }}
            >
              {fetching && listOffset === 0 ? (
                <TableLoader Rows={10} ColumnPerRow={7} />
              ) : (
                <>
                  <span style={{ color: "#7c8db0", fontSize: "13px" }}>
                    {employeeWithoutFillTimesheetList?.length
                      ? `Total ${employeeWithoutFillTimesheetList?.length} employee found`
                      : ""}
                  </span>

                  <div
                    style={{
                      display: employeeWithoutFillTimesheetList?.length
                        ? "grid"
                        : "",
                      gridTemplateColumns:
                        employeeWithoutFillTimesheetList?.length
                          ? "repeat(3,1fr)"
                          : "",
                      marginTop: "5px",
                    }}
                  >
                    {employeeWithoutFillTimesheetList?.length > 0 ? (
                      employeeWithoutFillTimesheetList?.map((data: any) => {
                        return (
                          <>
                            <div
                              className="xyz"
                              style={{
                                width: "225px",
                                height: "215px",
                                border: "1px solid #bfcbe1",
                                backgroundColor: "#fff",
                                borderRadius: "5px",
                                marginBottom: "20px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  padding: "25px 0",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  className="d-flex"
                                  style={{
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <LargeAvatar
                                    name={`${data?.user_name}`}
                                    image={
                                      data?.profile_pic &&
                                      data?.profile_pic?.file_url
                                    }
                                  />
                                </div>
                                <span
                                  style={{
                                    color: "#262a44",
                                    fontSize: "14px",
                                    marginTop: "20px",
                                    padding: "0 15px",
                                  }}
                                >
                                  {data?.user_name?.length > 25 ? (
                                    <OverlayTrigger
                                      placement="bottom"
                                      delay={{ show: 250, hide: 250 }}
                                      overlay={
                                        <Tooltip id="button-view">
                                          <div>
                                            <p className="mt-0 mb-0">
                                              {data?.user_name}
                                            </p>
                                            <p className="mt-0 mb-0">
                                              {data?.email}
                                            </p>
                                          </div>
                                        </Tooltip>
                                      }
                                    >
                                      <span>
                                        {data?.user_name
                                          .toLowerCase()
                                          ?.substr(0, 25) +
                                          (data?.user_name &&
                                          data?.user_name?.length > 20
                                            ? "..."
                                            : "")}
                                      </span>
                                    </OverlayTrigger>
                                  ) : (
                                    data?.user_name
                                  )}
                                </span>
                                <span
                                  style={{
                                    color: "#6e7491",
                                    fontSize: "12px",
                                    padding: "0 15px",
                                  }}
                                >
                                  {data?.email?.length > 25 ? (
                                    <OverlayTrigger
                                      placement="bottom"
                                      delay={{ show: 250, hide: 250 }}
                                      overlay={
                                        <Tooltip id="button-view">
                                          <div>
                                            <p className="mt-0 mb-0">
                                              {data?.user_name}
                                            </p>
                                            <p className="mt-0 mb-0">
                                              {data?.email}
                                            </p>
                                          </div>
                                        </Tooltip>
                                      }
                                    >
                                      <span>
                                        {data?.email
                                          .toLowerCase()
                                          ?.substr(0, 25) +
                                          (data?.email &&
                                          data?.email?.length > 20
                                            ? "..."
                                            : "")}
                                      </span>
                                    </OverlayTrigger>
                                  ) : (
                                    data?.email
                                  )}
                                </span>
                              </div>
                            </div>
                          </>
                        );
                      })
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                          height: "50vh",
                          margin: "auto",
                        }}
                      >
                        <div>
                          <p
                            style={{
                              fontSize: "25px",
                              fontFamily: "500",
                              color: "#262a44",
                              marginBottom: "2px",
                              margin: "auto",
                              marginLeft: "90px",
                            }}
                          >
                            No employees found!
                          </p>
                          <div
                            style={{
                              alignItems: "center",
                              fontSize: "13px",
                              color: "#262a44",
                              textAlign: "center",
                            }}
                          >
                            <p className="mb-0">
                              Congratulations! It looks like everyone has
                              submitted their timesheets on
                            </p>
                            <p className="mb-0">
                              time. Please contact Admin in case of further
                              assistance required.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default OpenEmployeeWithNoTimesheetEntry;
